export default __webpack_public_path__ + "static/data-more-about-img-44782fa002e6581c2ae76f43dd527c57.webp";